const toDateInputValue = (
  date
) => {
  const year =
    date.getFullYear();

  const month =
    String(
      date.getMonth() +
        1
    ).padStart(
      2,
      "0"
    );

  const day =
    String(
      date.getDate()
    ).padStart(
      2,
      "0"
    );

  return `${year}-${month}-${day}`;
};


export const getDateRangeForPreset =
  (
    preset
  ) => {
    const now =
      new Date();

    const start =
      new Date(now);

    const end =
      new Date(now);


    switch (
      preset
    ) {
      case "today":
        return {
          dateFrom:
            toDateInputValue(
              now
            ),

          dateTo:
            toDateInputValue(
              now
            ),
        };


      case "this_week": {
        const currentDay =
          now.getDay();

        const mondayOffset =
          currentDay === 0
            ? -6
            : 1 -
              currentDay;

        start.setDate(
          now.getDate() +
            mondayOffset
        );

        return {
          dateFrom:
            toDateInputValue(
              start
            ),

          dateTo:
            toDateInputValue(
              end
            ),
        };
      }


      case "this_month":
        start.setDate(
          1
        );

        return {
          dateFrom:
            toDateInputValue(
              start
            ),

          dateTo:
            toDateInputValue(
              end
            ),
        };


      case "this_year":
        start.setMonth(
          0,
          1
        );

        return {
          dateFrom:
            toDateInputValue(
              start
            ),

          dateTo:
            toDateInputValue(
              end
            ),
        };


      default:
        return {
          dateFrom: "",
          dateTo: "",
        };
    }
  };